@if (displayVersionInfo$()) {
  <div class="version-info-container">
    <span class="version-info-text ns" [matTooltip]="apiVersionInfo$()"
      >{{ frontendVersionInfo$() }} <br />
      {{ frontendBuildDate$() | date: "medium" }}</span
    >
  </div>
}
